import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const CartContext = createContext(null);

const STORAGE_KEY = "fbv_cart_v1";

export function CartProvider({ children }) {
  const [lines, setLines] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(lines));
  }, [lines]);

  const addLine = useCallback((line) => {
    setLines((prev) => {
      const existing = prev.findIndex(
        (l) => l.product_slug === line.product_slug && !line.configuration && !l.configuration,
      );
      if (existing >= 0 && !line.configuration) {
        const next = [...prev];
        next[existing] = { ...next[existing], quantity: next[existing].quantity + (line.quantity || 1) };
        return next;
      }
      return [...prev, { ...line, quantity: line.quantity || 1 }];
    });
  }, []);

  const removeLine = useCallback((idx) => {
    setLines((prev) => prev.filter((_, i) => i !== idx));
  }, []);

  const updateQty = useCallback((idx, qty) => {
    setLines((prev) => prev.map((l, i) => (i === idx ? { ...l, quantity: Math.max(1, qty) } : l)));
  }, []);

  const updateLine = useCallback((idx, patch) => {
    setLines((prev) => prev.map((l, i) => (i === idx ? { ...l, ...patch } : l)));
  }, []);

  const clear = useCallback(() => setLines([]), []);

  const subtotal = lines.reduce((sum, l) => sum + l.unit_price * l.quantity, 0);
  const count = lines.reduce((sum, l) => sum + l.quantity, 0);

  return (
    <CartContext.Provider value={{ lines, addLine, add: addLine, removeLine, updateQty, updateLine, clear, subtotal, count }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used within CartProvider");
  return ctx;
}
